import React from 'react'
import classnames from 'classnames'

const Action = ({ className, ...rest }) => (
  <button
    type="button"
    className={classnames(
      'text-sm font-semibold bg-transparent outline-none text-white text-opacity-50 focus:ring-2',
      className
    )}
    {...rest}
  />
)

export default Action
